import { useQuery } from '@tanstack/react-query';
import { useTacticHooks } from '../../providers/TacticHooksProvider';

export const useGetUserFavorites = () => {
  const { apiClient } = useTacticHooks();

  return useQuery({
    queryKey: ['favorites'],

    queryFn: async () => {
      return await apiClient.favorites.getFavorites();
    },

    enabled: !!apiClient.slug
  });
};
